module.exports = __webpack_public_path__ + "static/media/hero-screenshot-2.6f181902.png";